import roundTo from 'round-to'

const fahrenheitToCelsius = (fahrenheit, round=1) => {
  return roundTo((fahrenheit - 32) * 5 / 9, round);
}

export default fahrenheitToCelsius;
